<ul class="ae-tabs" (click)="changeTabsOptions($event)">
  <ng-content></ng-content>
</ul>
